/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import {
  getCurrentQtr,
  getCurrentDate,
} from '../../../../SharedModules/utilities/utilities';
import * as ActionTypes from './actionTypes';
const currentQtr = getCurrentQtr();
const currentDate = getCurrentDate('MM/DD/YYYY');
const initialState = {
  searchResult: [],
  rebateProgram: '',
  rebateProgramList: [],
  selectedPlanType: '',
  isLoading: false,
  planType: [],
  errors: [],
  validateValue: false,
  viewValue: true,
  qtrValue: currentQtr[0] + 'Q' + currentQtr[1],
  dateValue: currentDate,
  contractMfgGrid: [],
  contractDrugFamilyGrid: [],
  contractGrid: [],
  contractMarketBasketGrid: [],
  selectTypeValue: 'Manufacturer/Rebate Program',
  openValue: false,
  drugFamilyContractGrid: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    case ActionTypes.GET_REBATE_PROGRAM_CONTRACT_REPORT:
      return { ...state, rebateProgramList: action.payload };
    case ActionTypes.SET_CONTRACT_MFG_GRID:
      return { ...state, contractMfgGrid: action.payload };
    case ActionTypes.SET_CONTRACT_DRUG_FAMILY_GRID:
      return { ...state, contractDrugFamilyGrid: action.payload };
    case ActionTypes.SET_CONTRACT_MARKET_BASKET_GRID:
      return { ...state, contractMarketBasketGrid: action.payload };
    case ActionTypes.SET_CONTRACT_GRID:
      return { ...state, contractGrid: action.payload };
    case ActionTypes.SET_DRUG_FAMILY_CONTRACT_GRID:
      return { ...state, drugFamilyContractGrid: action.payload };
    case ActionTypes.SET_OPEN_VALUE:
      return { ...state, openValue: action.payload };
    case ActionTypes.SET_ERROR_MESSAGE:
      return { ...state, errors: action.payload };

    case ActionTypes.REFRESH_CONTRACT_REPORT:
      return initialState;

    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: action.isLoading };

    default:
      return state;
  }
};

export default reducer;
